import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function VouchersPage(){return <ExtendedModulePage moduleKey="vouchers"/>}
